<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="450">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="error" dark v-on="on">retirer</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Retrait USDT<img
                    src="/img/usdt.svg"
                    width="40"
                    style="margin: 3px"
                    alt="cfa"
                  />
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-if="formulaire">
            <v-text-field solo type="number" label="Montant" v-model="amount" class="input_amount mr-5" ></v-text-field>
            <v-btn color="primary" @click="tout">Max</v-btn>
            <p class="caption">Frais de Réseau : 1 USDT <span v-if="amount > 1" class="red--text ml-5"> TOTAL: {{Number(amount) + 1}} </span> </p>
            <div class="center">
                  <v-select
                        :items="networks"
                        v-model="network"
                        label="Choisir le reseau"
                        @change=""
                    ></v-select>
              </div> 
            <v-text-field solo type="text" :label="`adresse USDT ${network}`" v-model="address" ></v-text-field>
            <p v-if="!valid_wallet && address.length> 2" class="red--text">adresse de reception invalide</p>
            <p v-if="valid_wallet && address.length> 5" class="green--text">adresse valide</p>
            <p v-if="require_wallet" class="red--text">adresse de reception obligatoire</p>
            <v-flex xs12 text-xs-center>
              <v-btn type="submit" color="success" @click.prevent="submit()" :disabled ='!valid_wallet' >Retirer</v-btn>
            </v-flex>
            <v-flex xs12 text-xs-center>
              <p class="red--text subheader" v-if="hmm">solde insuffisant</p>
            </v-flex>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div  id="rendu" v-show="false"></div>

    <div>
      <v-dialog v-model="dialog_2fa" max-width="800">
        <v-card>
          <v-card-title class="headline grey lighten-2 pa-3" primary-title>
            <div style="display:block; text-align:center; margin:auto;">Google 2-FA</div>
          </v-card-title>

          <v-card-text class="px-3 pt-1 mb-4">
            <div style="display:block; max-width:100%; text-align:center">
              <img src="/img/2fa.svg" width="70" alt />
            </div>
            <p
              class="caption"
              style="display:block; max-width:100%; text-align:center"
            >Entrez le code à 6 chiffres pour confirmer le retrait</p>
            <div class="pl-4" style="text-align:center">
              <input
                class="code"
                v-model="code"
                type="number"
                onkeypress="if(this.value.length==6) return false;"
              />
              <br />
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog_2fa= false">fermer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>


<script>
import firebase from "../../../fb";
import db from "../../../db";
import { mapGetters } from "vuex";
var bcrypt = require("bcryptjs");
import axios from "axios";
export default {
  data() {
    return {
      pass: process.env.VUE_APP_SECRET,
      code: "",
      address: '',
      dialog_2fa: false,
      hmm: false,
      formulaire: true,
      valid_wallet:'',
      require_wallet:false,
      amount: "",
      
      dialog: false,
      fired:false,
      networks: ["TRC20", "BSC(BEP20)"],
      network: '',
      nameRules: [
        (v) => !!v || "obligatoire",
      ],
      fee: null,
    };
  },
  computed: {
    total() {
      return Number(this.amount) + 1;
    },
    ...mapGetters({
      pm: "authfb/pm",
      user: "authfb/user",
    }),
  },
  watch: {
    code(newValue, oldValue) {
      if (newValue.length == 6) {
        this.validate();
      }
    },

    address(newValue, oldValue){
       this.valid_address()
    },
    network(newValue, oldValue){
       this.valid_address()
    },
  },
  methods: {
    tout() {
      var pm = Number(this.$store.getters["authfb/usdt"]);
      this.amount = Math.floor(pm) - 1
    },

    valid_address (){
        let pm_regex = /^[U][0-9]{8}?$/.test(this.address)
       let btc_regex = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/.test(this.address)
       let eth_regex = /^0x[a-fA-F0-9]{40}$/.test(this.address)
       let trc_regex = /\bT[a-zA-Z0-9]{20,45}$/.test(this.address)
       let eth_bsc_network = ['ERC20', 'BSC(BEP20)']
       eth_bsc_network.indexOf(this.network)>= 0? this.valid_wallet= eth_regex  :''
       this.network == 'TRC20' ? this.valid_wallet =trc_regex :''
          //   switch (this.currency) {
          //   case 'BTC': this.valid_wallet= btc_regex
          //     break;
          //     case 'PM': this.valid_wallet= pm_regex
          //     break;
          //   default: ''
          //     break;
          // }
        },

    submit() {
      
      console.log('hii fired');

      let usdt = Number(this.$store.getters["authfb/usdt"]);
     
      if (this.$refs.form.validate()) {
          let network
          this.network == 'BSC(BEP20)'? network = 'BSC' : '' 
          this.network == 'TRC20'? network = 'TRX' : ''
          let min_amount  = network == 'BSC' ? 5  : 10;

          if (this.amount >= min_amount) {
            if (this.total <= usdt) {
              this.dialog = false;
              if (this.user.auth2fa.google) {
                this.dialog_2fa = true;
                return;
              }

              swal({
                text: "CODE PIN",
                content: {
                  element: "input",
                  attributes: {
                    placeholder: "Enter PIN",
                    type: "password",
                  },
                },
                button: {
                  text: "confirm",
                  closeModal: false,
                },
              }).then((value) => {
                var hash = this.$store.getters["authfb/pin"];
                bcrypt.compare(value, hash).then((res) => {
                  if (res) {
                    this.dispatchWithdraw();
                  } else {
                    swal("incorrect PIN!", "", "error", {
                      button: "ok",
                    });
                    this.dialog = true;
                  }
                });
              });
            } else {
              swal("Solde insuffisant!", "", "error", {
                button: "ok!",
              });
            }
          } else {
            swal(`Montant minimum : ${min_amount} usdt`, "veillez changer le montant", "error", {
              button: "ok",
            });
          }

          
        
      }
    },

    async dispatchWithdraw(){
      let result =  db.collection("transactions").doc("usdt").collection("usdt_withdraw").doc()
      let user =  firebase.auth().currentUser;
      let network
      this.network == 'BSC(BEP20)'? network = 'BSC' : '' 
      this.network == 'TRC20'? network = 'TRX' : ''
      
      let data = {
      id: result.id,
      user_id: user.uid,
      amount: Number(this.amount),
      didact_amount: Number(this.total),
      network ,
      fee: 1,
      address: this.address,
      status: 'attente',
      asset:'usdt',
      created_at: ''
    }

    let base_url = this.base_url
              if (location.hostname === "localhost") {
                  base_url = 'http://localhost:4000'
                }
        let url = base_url + '/payment/withdraw'
        let request_headers = await this.get_headers(data)
        let {asset, amount, address, id} =data
        let post_data = {asset, amount, address, id}
        console.log(request_headers);
      axios.post(url, post_data,request_headers ).then(result => {
        console.log(result.data);
      })
    },

    validate() {
      let token = this.code
        let valid = this.verify_2fa(token)
        console.log(valid);

        if (valid) {
            this.dispatchWithdraw();
            this.dialog_2fa = false
            this.code = "";

            const noti = this.$vs.notification({
                  color: 'success',
                  position: 'top-right',
                  title: 'Success',
                  text: '2FA correct, retrait en cours'
                })
            
          } else {
            this.$vs.loading().close();
            swal("code 2FA invalide!", "", "error", {
              button: "ok!",
            });
            this.code = "";
          }
    },
  },
};
</script>

<style scoped>
.first {
  font-size: 2em;
  max-width: 190px;
  font-weight: 400;
  display: block;
}
.pm_account {
  font-size: 2em;
  max-width: 250px;
  display: block;
  margin: auto;
}
.fee {
  max-width: 200px;
  display: block;
  margin: auto;
}
</style>
